module.exports = __webpack_public_path__ + "img/key.d75c4af6.png";